<template>
  <div class="common-modal">
    <transition name="fade">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <form class="modal-container">
            <div class="modal-body">
              <div class="background-image">
                <img class="bg" :src="`${$store.state.appUrl}/img/pwa/app/${bgImage}.svg`" />
                <img class="dog" :src="`${$store.state.appUrl}/img/pwa/app/dog.png`" />
              </div>
              <div class="information">
                <h2 class="popup_head text-primary text-center font-bold">
                  {{ title }}
                </h2>
                <p>{{ text }}</p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                v-ripple
                type="button"
                class="btn-active btn-full popup-btn"
                @click="$emit('connect')"
              >
                <span class="popup-text block">{{ $t("connect") }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Button from "../UI/Button";
export default {
  name: "PaymentModal",
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    bgImage: {
      type: String,
      default: ''
    }
  },
  components: {
    Button
  }

};
</script>
<style lang="scss" scoped>
.common-modal {
  .bg {
    position: absolute;
    top: -1px;
    left: 0;
  }
  .dog {
    position: absolute;
    top: 85px;
    right: 62px;
  }
  .background-image {
    width: 309px;
    height: 290px;
  }
  .popup_head {
    font-size: 31px;
  }
  .information {
    position: relative;
    margin-top: -40px;
    p {
      text-align: center;
      font-size: 19px;
      font-weight: 500;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    
  }
  button.popup-btn {
    font-weight: 500 !important;
    background-color: var(--bg-color);
    color: #fff;
    border-radius: 49px;
    margin-left: 34px;
    width: 162px;
    height: 44px;
  }
  .modal-container {
    border-radius: 36px !important;
    position: relative;
  }
}
</style>
